/* eslint-disable react-refresh/only-export-components */

import { createContext, useContext } from 'react';
import { Session, User } from '@supabase/supabase-js';

type AuthContextType = {
  session: Session | null;
  user: User | null;
  profile: unknown | null;
  loading: boolean;
  signIn: (email: string, password: string, rememberMe?: boolean) => Promise<unknown>;
  signUp: (email: string, password: string, fullName: string) => Promise<unknown>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Re-export the AuthProvider from the providers folder
export { AuthProvider } from '@/providers/AuthProvider';
